'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colmo = require('../../mixins/colmo');

var _colmo2 = _interopRequireDefault(_colmo);

var _diablo = require('../../mixins/diablo');

var _diablo2 = _interopRequireDefault(_diablo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var dom = weex.requireModule('dom');
var modal = weex.requireModule('modal');
exports.default = {
  components: {},
  mixins: [_colmo2.default, _diablo2.default],
  props: {
    small: {
      type: Boolean,
      default: false
    },
    dot: {
      type: Boolean,
      default: false
    },
    content: {
      type: [Number, String],
      default: ''
    },
    max: {
      type: Number,
      default: 0
    },
    theme: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    inline: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      eleWidth: 0,
      eleHeight: 0
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      var ele = _this.$refs.dofBadge;
      !_this.inline && _this.getEleSize(ele);
    });
  },

  computed: {
    themeList: function themeList() {
      return {
        brand: this._isDiablo ? '#0490d3' : '#00A4F2',
        red: this._isDiablo ? '#DB5C44' : '#F56428',
        purple: this._isDiablo ? '#805ed1' : '#946CF2',
        'blue-purple': this._isDiablo ? '#5865DC' : '#6575ff',
        blue: this._isDiablo ? '#25A8DC' : '#29c3ff',
        cyan: '#00cbb8',
        yellow: this._isDiablo ? '#BE8214' : '#FFAA10',
        orange: this._isDiablo ? '#db7122' : '#ff8225',
        'orange-red': '#ff6a4c',
        'gray-offline': this._isDiablo ? '#6B7587' : '#7c879b',
        colmo: '#B35336',
        'colmo-gray': '#737374'
      };
    },
    theme_: function theme_() {
      if (this.theme) return this.theme;
      return this._isColmo ? 'colmo' : 'red';
    },
    contentValue: function contentValue() {
      var max = this.max,
          content = this.content;

      var value = '';
      var curContent = Number(content);
      if (max && curContent >= max) {
        value = max + '+';
      } else {
        value = content;
      }
      return value;
    },

    //是否行内展示，改变定位
    activeBoxPosClass: function activeBoxPosClass() {
      var inline = this.inline;

      return inline ? '' : 'dof-badge';
    },
    activeBoxClass: function activeBoxClass() {
      var dot = this.dot,
          small = this.small;

      var b_class = '';
      if (dot) {
        b_class = small ? 'dof-badge-dot-small' : 'dof-badge-dot-default';
      } else {
        b_class = small ? 'dof-badge-text-small' : 'dof-badge-text-default';
      }
      return b_class;
    },
    activeTextClass: function activeTextClass() {
      var small = this.small;

      var t_class = '';
      t_class = small ? 'text-desc-small' : 'text-desc-default';
      return t_class;
    },
    badgeStyle: function badgeStyle() {
      var theme_ = this.theme_,
          themeList = this.themeList,
          color = this.color;

      return {
        backgroundColor: color ? color : themeList[theme_]
      };
    }
  },
  methods: {
    getEleSize: function getEleSize(ele) {
      var self = this;
      dom.getComponentRect(ele, function (result) {
        var size = result.size || {};
        var width = parseInt(size.width);
        var height = parseInt(size.height);
        if (!width || !height) {
          self.getEleSize(ele);
        } else {
          self.eleWidth = width;
          self.eleHeight = height;
          self.$emit('dofStyleHandle', { width: width, height: height });
        }
      });
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-badge/index.vue
// module id = 307
// module chunks = 0 1